import Bouncer from 'formbouncerjs';
import {
  isFormProcessing,
  markFormProcessing,
  grecaptchaV3Execute,
  logToPHP,
  glsAjax,
} from './scripts';
import {
  subscribeToEveryAction,
  wantsOptIn,
} from './ea';

const $j = jQuery.noConflict();
let supressTaxMessage = true;
// let timer;
let prevState = '';
const paymentObject = {
  method: 'none',
  amount: '',
};

function formatCurrency(total) {
  let neg = false;
  let workingTotal = total;

  if (total < 0) {
    neg = true;
    workingTotal = Math.abs(total);
  }

  return (neg ? '-$' : '$')
    + parseFloat(workingTotal, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,').toString();
}

function fadeOutMessages() {
  $j("div[name$='-message']").fadeOut(250).html('');
}

let focusCount = 0;

function onFocusFadeOutMessages() {
  $j('input').on('focus', function handleFocus() {
    focusCount += 1;
    if (focusCount === 2) {
      fadeOutMessages();
      $j('input').off('focus', handleFocus);
      focusCount = 0;
    }
  });
}

function addMessage(placeId, msg, color = 'red') {
  const el = $j(`#${placeId}`);
  const finalMsg = (color !== 'red')
    ? `<span style="color:${color}">${msg}</span>`
    : msg;

  // Check if the message already exists
  if (!el.html().includes(finalMsg)) {
    const lineBreak = (el.html() !== '') ? '<br>' : '';
    el.html(`${el.html()}${lineBreak}${finalMsg}`);
  }

  el.fadeIn(400);
  onFocusFadeOutMessages();
}

function toTitleCase(str) {
  return str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
  );
}

function onDiscountDonationChange(el) {
  const preFormat = parseFloat(el.val().replace('$', '').replace(',', ''));

  if ($j.isNumeric(preFormat) && preFormat >= 0) {
    el.val(formatCurrency(preFormat));
  } else {
    el.val(formatCurrency(0));
    if (el === '#discount') {
      addMessage('grand-total-message', `Invalid ${toTitleCase(el.attr('name'))}.`);
    }
  }
}

function stateValueSetter(adjustedElement) {
  $j('#state').val(adjustedElement.val());
}

function updateAddressFieldsToCountry() {
  const stateLabel = $j('.state-label');
  const stateList = $j('#us-states');
  const provinceList = $j('#canada-provinces');
  const provinceOther = $j('#other-country-province');
  const shippingCountryRow = $j('#shipping-country-row');
  const zipLabel = $j('.zip-label');
  const country = $j('#country').val();
  const shippingCountryVal = $j('#shipping-country').val();

  if (country === 'us') {
    stateLabel.html('State');
    zipLabel.html('Zip Code');

    provinceList.hide();
    stateList.show();
    provinceOther.hide();
    shippingCountryRow.hide();
    stateValueSetter(stateList);
  } else {
    stateLabel.html('State/Province');
    zipLabel.html('Postal Code');

    stateList.hide();
    shippingCountryRow.show();
    if (shippingCountryVal === 'Canada') {
      provinceOther.hide();
      provinceList.show();
      stateValueSetter(provinceList);
    } else {
      provinceList.hide();
      stateList.hide();
      stateList.hide();
      provinceOther.show();
      stateValueSetter(provinceOther);
    }
  }
}

function updateStateAndCountryShipAlert() {
  let state = $j('#state').val();
  state = state.toUpperCase();
  $j('#state').val(state);
  const country = $j('#country').val();
  const itemQty = $j('#item-ship-qty').val();

  if (country === 'us') {
    if (state === 'AK' || state === 'HI' || state === 'PR') {
      // $j("#chosen-state").html($j("#state").val());
      // Jack edited to show capitalized state in flash 2014.11.11
      $j('#chosen-state').html(state);
      $j('#state-alert').show(400);
      $j('#delivery-time-us').hide();
      $j('#delivery-time-us-extended').show();
      $j('#delivery-label').attr('for', 'delivery-time-us-extended');
      // feedback
      //
      $j('#USE_THIS_DELIVERY_TIME').val($j('#delivery-time-us-extended').val());
      if ($j('#delivery-time-us-extended').val() === 'pri-us-extended') {
        if (itemQty > 1) {
          $j('#item-alert').show(400);
        } else {
          $j('#item-alert').hide(400);
        }
      } else {
        $j('#item-alert').hide(400);
      }
    } else {
      $j('#state-alert').hide(400);
      $j('#delivery-time-us').show();
      $j('#delivery-label').attr('for', 'delivery-time-us');
      $j('#delivery-time-us-extended').hide();
      // feedback
      //
      $j('#USE_THIS_DELIVERY_TIME').val($j('#delivery-time-us').val());
      if ($j('#delivery-time-us').val() === 'pri-us') {
        if (itemQty > 1) {
          $j('#item-alert').show(400);
        } else {
          $j('#item-alert').hide(400);
        }
      } else {
        $j('#item-alert').hide(400);
      }
    }
    $j('#submit-message').hide(400);
    $j('#delivery-time-intl').hide();
    $j('#country-item-alert').hide(400);
  } else {
    $j('#state-alert').hide(400);
    $j('#submit-message').show(400);
    $j('#item-alert').hide(400);
    $j('#delivery-time-us').hide();
    $j('#delivery-time-us-extended').hide();
    $j('#delivery-time-intl').show();
    $j('#delivery-label').attr('for', 'delivery-time-intl');
    // feedback
    //
    $j('#USE_THIS_DELIVERY_TIME').val('pri-intl');
    if (itemQty > 1) {
      $j('#country-item-alert').show(400);
    } else {
      $j('#country-item-alert').hide(400);
    }
  }
}

function sendToPayPal(code) {
  // console.log('sending to paypal');

  if ($j('#liveOrTest').val() === 'test') {
    addMessage('result', "Hello, tester! You're done. No PayPal for you!", 'green');
    return;
  }

  addMessage('result', 'Redirecting to PayPal...', 'green');

  window.setTimeout(() => {
    let url;
    let paypalEmail;
    let debug = false;
    const hn = window.location.hostname;

    if (
      hn === 'dev.veganoutreach.org'
      || hn === 'staging.veganoutreach.org'
    ) {
      debug = true;
      addMessage('result', 'SANDBOX', 'green');
    }

    if (debug) {
      url = 'https://www.sandbox.paypal.com/cgi-bin/webscr?';
      paypalEmail = 'give-facilitator@veganoutreach.org';
    } else {
      url = 'https://www.paypal.com/cgi-bin/webscr?';
      paypalEmail = 'give@veganoutreach.org';
    }

    window.location.href = `${url
    }cmd=_donations&`
      + `business=${paypalEmail}&`
      + 'lc=US&'
      + 'item_name=Vegan%20Outreach&'
      + `amount=${paymentObject.amount}&`
      + 'currency_code=USD&'
      + 'no_note=0&'
      + 'cn=Add%20special%20instructions%20to%20the%20seller&'
      + 'no_shipping=1&'
      + `custom=${code}&`
      + 'notify_url='
      + `https://${hn}/paypal-return&`
      + 'return='
      + `https://${hn}/order-thank-you&`
      + 'bn=PP-DonationsBF:btn_donateCC_LG.gif:NonHosted';
  }, 6000);
}

function redirectToPayment(code) {
  if (
    paymentObject.method === 'PayPal'
    && paymentObject.amount !== ''
  ) {
    // console.log('redirecting to payment - PayPal');
    sendToPayPal(code);
  } else {
    // console.log('ERROR - redirecting to payment');
    // console.log(paymentObject);
    // console.log(code);
  }
}

async function submitOrder(submittingForm) {
  paymentObject.method = $j('#payment_method').val();

  if (paymentObject.method === 'PayPal') {
    paymentObject.amount = $j('#paypal-amount').val();
  }

  const data = $j('#catalog-order-form').serializeFormJSON();
  data.action = 'order_form_submission';
  data.enews = (wantsOptIn(submittingForm, 'enews')) ? '1' : '0';
  let response;

  try {
    response = await glsAjax({ data });
  } catch (err) {
    logToPHP(`order_form_submission ajax error. ${JSON.stringify(err)}`);
    addMessage('result', 'Sorry, there was an error processing your order (err:01). Please let us know at info@veganoutreach.org.');
    markFormProcessing(submittingForm, false);
    return;
  }

  if (!response.success) {
    addMessage('result', response.msg);
  } else if (response.code === '') {
    addMessage('result', 'Sorry, there was an error processing your order (err:02). Please let us know at info@veganoutreach.org.');
  } else {
    addMessage('result', response.msg, 'green');
    redirectToPayment(response.code);
  }
}

// manually clear all messages
// timed clearing happens another way
function clearMessagesHTML() {
  $j("div[name$='-message']").html('');
  $j("div[name='result']").html('');
}

function upToOrAtIncrementsOf(target, qty) {
  if (qty > target && qty % target) {
    const overTarget = qty % target;
    //
    // always round down
    //
    return qty - overTarget;

    // to restore rounding at the half, comment the above and uncomment the below
    //
    // if (overTarget < (target / 2)) {
    //   // round down
    //   //
    //   return qty - overTarget;
    // }
    // // round up
    // //
    // return qty + (target - overTarget);
  }
  if (qty < 0) {
    return 0;
  }
  return qty;
}

function updatePaymentButton() {
  if ($j('#grand').val().replace('$', '').replace(',', '') >= 0.01) {
    $j('#paypal_panel').show();
    $j('#submit-button').hide();
    $j('#submit-message').empty();
  } else if ($j('#grand').val() === '$0.00') {
    $j('#paypal_panel').hide();
    $j('#submit-button').show();
  } else {
    $j('#paypal_panel').hide();
    $j('#submit-button').show();
  }
}

// TODO get bouncer to replace this
//
function validateOrderForm() {
  let isValid = true;

  // something ordered?
  //
  if ($j('#subtotal').val() === '$0.00') {
    addMessage('submit-message', 'Select items to order above before continuing.');
    isValid = false;
  }

  return isValid;
}

function isCounting(contender) {
  return (
    Math.floor(contender) === parseInt(contender, 10)
    && $j.isNumeric(contender)
    && contender > 0
  );
}

function totFromQtyAndPrice(qty, price) {
  if (isCounting(qty)) {
    // get the price
    //

    if ($j.isNumeric(price)) {
      // update total
      //
      return qty * price;
    }

    // price error - show 0
    //
    return 0;
  }

  // qty not a counting number - show 0
  //
  return 0;
}

function totFromQtyAndPacket(qty, packetsize) {
  if (isCounting(qty)) {
    // get the packetsize
    //

    if ($j.isNumeric(packetsize)) {
      // update total
      //
      return qty * packetsize;
    }

    // packetsize error - show 0
    //
    return 0;
  }

  // qty not a counting number - show 0
  //
  return 0;
}

function zeroOrNumber(num) {
  return (isCounting(num)) ? parseInt(num, 10) : 0;
}

function updateBookletShipQty() {
  let shipQty = 0;

  $j('.updatesBookletShipQty').each(function loopUpdatesBookletShipQty() {
    shipQty += zeroOrNumber($j(this).val());
  });

  $j('#booklet-ship-qty').val(shipQty);
}

function updateItemShipQty() {
  let shipQty = 0;

  $j('.updatesItemShipQty').each(function loopUpdatesItemShipQty() {
    shipQty += zeroOrNumber($j(this).val());
  });

  $j("input[name$='_sq'], select[name$='_sq']").change(function loopSQ() {
    shipQty += zeroOrNumber($j(this).val());
  });

  $j('#item-ship-qty').val(shipQty);
  $j('#total-qty-items').val(shipQty);
}

function sum(obj) {
  // let sum = 0;
  // for (const el in obj) {
  //   if (Object.prototype.hasOwnProperty.call(obj, el)) {
  //     sum += parseFloat(obj[el]);
  //   }
  // }
  return Object.values(obj).reduce((acc, cur) => acc + parseFloat(cur), 0);
}

function applyUsRegShippingCharges(qtys) {
  // update code for a base price of $6 plus 1 for each additional item
  //
  let fees = 0;

  if (qtys >= 1) {
    fees = (qtys * 1) + 4;
  }

  return fees;
}

function applyUsPriorityShippingCharges(qtys) {
  // update code for a base price of $10
  // up to 12 items $16
  // 13+ items $16.00 + ($16.00 * (# of items / 12 ))
  //
  let fees = 0;
  const envelopeSize = 1;
  const boxSize = 12;

  if (qtys === 1) {
    fees = 10;
  } else if (qtys > envelopeSize && qtys <= boxSize) {
    fees = 16;
  } else if (qtys >= 13) {
    fees = 16 * Math.floor(qtys / boxSize);
    if (qtys % boxSize > 0) {
      fees += 16;
    }
  }

  return fees;
}

function applyIntlPriorityShippingCharges(qtys) {
  // update code for a base price of $30
  // up to 12 items $60
  // 13+ items $60.00 + ($60.00 * (# of items / 12 ))
  //
  let fees = 0;
  const envelopeSize = 1;
  const boxSize = 12;

  if (qtys === 1) {
    fees = 30;
  } else if (qtys > envelopeSize && qtys <= boxSize) {
    fees = 60;
  } else if (qtys >= 13) {
    fees = 60 * Math.floor(qtys / boxSize);
    if (qtys % boxSize > 0) {
      fees += 60;
    }
  }

  return fees;
}

function applyCanadaRegShippingCharges(qtys) {
  const fees = {};
  fees.booklets = 0;
  fees.bookmarks = 0;
  fees.books = 0;
  fees.bumperstickers = 0;
  fees.buttons = 0;
  fees.cloth = 0;
  fees.DVDs = 0;
  //
  // booklets
  //
  if (qtys.booklets < 1) {
    fees.booklets = 0;
  } else if (qtys.booklets < 6) {
    fees.booklets = 3;
  } else if (qtys.booklets < 25) {
    fees.booklets = 5;
  } else if (qtys.booklets < 51) {
    fees.booklets = 7;
  } else if (qtys.booklets < 101) {
    fees.booklets = 19;
  } else if (qtys.booklets < 201) {
    fees.booklets = 50;
  } else if (qtys.booklets < 301) {
    fees.booklets = 50;
  } else if (qtys.booklets < 501) {
    fees.booklets = 0.15 * qtys.booklets;
  } else if (qtys.booklets < 1001) {
    fees.booklets = 0.09 * qtys.booklets;
  } else if (qtys.booklets < 2001) {
    fees.booklets = 0.08 * qtys.booklets;
  } else {
    fees.booklets = 0.06 * qtys.booklets;
  }
  //
  // bookmarks (bookmarks, small stickers, and window clings)
  // -- $1.45 for first one, $.50 for each above that
  //
  if (qtys.bookmarks > 0) {
    fees.bookmarks = (qtys.bookmarks * 0.5) + 0.95;
  }
  //
  // books (only heavy books such as Betty Goes Vegan)
  // -- $26 for first one, $2 for each above that
  //
  if (qtys.books > 0) {
    fees.books = (qtys.books * 2) + 4;
  }
  //
  // bumperstickers (large stickers, magnets)
  // -- $4 for first one, $1 for each above that
  //
  if (qtys.bumperstickers > 0) {
    fees.bumperstickers = (qtys.bumperstickers * 1) + 1.25;
  }
  //
  // buttons (buttons, necklaces, collars, restaurant and VMP cards, totes, PopSockets)
  // -- $10 for first one, $.50 for each above that
  //
  if (qtys.buttons > 0) {
    fees.buttons = (qtys.buttons * 0.5) + 5;
  }
  //
  // cloth (shirts, tanks, hoodies)
  // -- $17.50 for first one, $2 for each above that
  //
  if (qtys.cloth > 0) {
    fees.cloth = (qtys.cloth * 2) + 4;
  }
  //
  // DVDs (DVDs and lighter books)
  // -- $17.50 for first one, $2 for each above that
  //
  if (qtys.DVDs > 0) {
    fees.DVDs = (qtys.DVDs * 2) + 4;
  }
  //
  // consolidate
  //
  return sum(fees);
}

function updateShipping() {
  //
  // prep quantities
  //
  // const qtys = {};
  // switch to single item plus additional calculation
  const qtys = zeroOrNumber($j('#item-ship-qty').val());
  let fees = {};

  // console.log("updateShipping");
  // console.log(qtys);
  // console.log($j("#USE_THIS_DELIVERY_TIME").val());

  // calc the price
  //
  switch ($j('#USE_THIS_DELIVERY_TIME').val()) {
    case 'reg-us':
      fees = applyUsRegShippingCharges(qtys);
      break;
    case 'pri-us':
      fees = applyUsPriorityShippingCharges(qtys);
      break;
    case 'reg-us-extended':
      fees = applyUsRegShippingCharges(qtys);
      break;
    case 'pri-us-extended':
      fees = applyUsPriorityShippingCharges(qtys);
      break;
    case 'reg-canada':
      fees = applyCanadaRegShippingCharges(qtys);
      break;
    case 'pri-intl':
      fees = applyIntlPriorityShippingCharges(qtys);
      break;
    default:
      fees = 0;
      break;
  }
  //
  // output
  //
  $j('#shipping').val(formatCurrency(fees));
}

function updateTax() {
  let tax = 0;
  const taxEl = $j('#tax');
  const taxPrev = taxEl.val();
  let taxStr = '';
  let tempTotal = 0;
  $j('input[name$=_t]').not('.tax-exempt').each(function loopInputTNotTaxExempt() {
    tempTotal = parseFloat($j(this).val().replace('$', '').replace(',', ''));

    if ($j.isNumeric(tempTotal)) {
      tax += tempTotal * 0.08;
    }
  });

  tax = ($j('#state').val().toUpperCase() === 'CA') ? tax : 0;
  taxStr = formatCurrency(tax);
  taxEl.val(taxStr);

  if (
    taxStr !== taxPrev
    && !supressTaxMessage
  ) {
    addMessage('subtotal-message', 'Sales tax (applied to orders from California) has been updated.');
    supressTaxMessage = false;
  }
}

function grandTotal() {
  // get the numbers
  //
  let subtotal = parseFloat($j('#subtotal').val().replace('$', '').replace(',', ''));
  let shipping = parseFloat($j('#shipping').val().replace('$', '').replace(',', ''));
  let tax = parseFloat($j('#tax').val().replace('$', '').replace(',', ''));
  let donation = parseFloat($j('#donation').val().replace('$', '').replace(',', ''));
  let discount = parseFloat($j('#discount').val().replace('$', '').replace(',', ''));
  // validate
  //
  if (!$j.isNumeric(subtotal)) {
    subtotal = 0;
  }
  if (!$j.isNumeric(shipping)) {
    shipping = 0;
  }
  if (!$j.isNumeric(tax)) {
    tax = 0;
  }
  if (!$j.isNumeric(donation)) {
    donation = 0;
  }
  if (!$j.isNumeric(discount)) {
    discount = 0;
  }

  // enforce maximum discount
  //
  let maxDiscount = 0;
  let tempTotal = 0;
  $j('.discountable').each(function loopDiscountable() {
    tempTotal = parseFloat($j(this).val().replace('$', '').replace(',', ''));
    if ($j.isNumeric(tempTotal)) {
      maxDiscount += tempTotal;
    }
  });
  //
  // reduce discount to max discount
  //
  if (discount > maxDiscount) {
    discount = maxDiscount;
    $j('#discount').val(formatCurrency(maxDiscount));
    addMessage('grand-total-message', `Maximum discount is ${formatCurrency(maxDiscount)}.`);
  }
  //
  // update shipping
  //
  updateShipping();
  //
  // update grand total
  //
  const grand = subtotal + shipping + tax + donation - discount;
  $j('#grand').val(formatCurrency(grand));
  $j('.pay-total').html(formatCurrency(grand));
}

function totals() {
  let subtotal = 0;
  let tempTotal = 0;
  $j('input[name$=_t]').each(function loopInputT() {
    tempTotal = parseFloat($j(this).val().replace('$', '').replace(',', ''));
    if ($j.isNumeric(tempTotal)) {
      subtotal += tempTotal;
    }
  });
  // subtotal display
  //
  $j('#subtotal').val(formatCurrency(subtotal));
  // tax
  //
  updateTax();
  //
  // update shipping
  //
  updateShipping();
  //
  // update display
  //
  grandTotal();
  updatePaymentButton();
}

function keepFormUpToDate() {
  // running these fought with the user input attempts
  // onDiscountDonationChange($j('#donation'));
  // onDiscountDonationChange($j('#discount'));
  updateAddressFieldsToCountry();
  const state = $j('#state').val();

  if (state !== prevState) {
    prevState = state;
    updateStateAndCountryShipAlert();
    totals();
  }
}

function onStateChange(el) {
  stateValueSetter(el);
  //
  // shipping
  //
  // updateStateAndCountryShipAlert();
  // taxes
  //
  totals();
}

function onDeliveryTimeChange() {
  //
  // shipping
  //
  updateStateAndCountryShipAlert();
  // taxes
  //
  totals();
}

function onCountryChange() {
  //
  // state is effected by country choice
  //
  updateStateAndCountryShipAlert();
  updateAddressFieldsToCountry();
  //
  // update shipping and totals
  // don't let people pay if ordering outside of US and Canada
  //
  totals();
}

$j(() => {
  if ($j('#catalog-order-form').length > 0) {
    const bouncer = new Bouncer('#contact-form', {
      disableSubmit: true,
    });

    updateItemShipQty();
    $j('#donation').val(formatCurrency(0));
    $j('#discount').val(formatCurrency(0));
    updatePaymentButton();
    updateStateAndCountryShipAlert();
    updateAddressFieldsToCountry();
    totals();

    $j("input[name$='_q'], select[name$='_q']").change(function loopQ() {
      const el = $j(this);

      // which field? (get the prefix)
      //
      const fieldPrefix = (el.attr('name').split('_'))[0];

      // validate qty counting number
      //
      let qtySubmitted = parseInt(el.val(), 10);
      let qty = qtySubmitted;

      if (!isCounting(qty)) {
        qty = Math.floor(qty);
        qty = (qty > 0) ? qty : 0;
        // handle error silently
        qtySubmitted = 0;
      }

      const maxValue = el.attr('max');

      if (typeof maxValue !== typeof undefined && maxValue !== false) {
        if (qty > maxValue) {
          qty = maxValue;
        }
      }

      // validate qty against restrictions
      //
      if (el.hasClass('incrementsOf50')) {
        qty = upToOrAtIncrementsOf(50, qty);

        if (qtySubmitted !== qty) {
          addMessage(
            'booklet-message', `Your quantity has been changed from ${
              qtySubmitted} to ${qty
            }. This booklet can be ordered in singles up to 50 or in multiples of 50.`,
          );
        }
      }

      // qty is now valid
      //
      el.val(qty);

      // get the price as a number
      //
      const price = $j(`#${fieldPrefix}_c`).html().toString().replace('$', '')
        .replace(',', '');

      // get the line total
      //
      const total = totFromQtyAndPrice(qty, price);

      // display it
      //
      $j(`#${fieldPrefix}_t`).val(formatCurrency(total));

      // get the booklet total as a number
      //
      const packetSize = (el.attr('class').split('_'))[1];

      // get the total number of packets
      //
      const totalBooklets = totFromQtyAndPacket(qty, packetSize);

      // display it
      //
      $j(`#${fieldPrefix}_b`).val(totalBooklets);

      updateBookletShipQty();
      updateItemShipQty();
      onDeliveryTimeChange();
      totals();
    });

    $j("input[name$='_sq'], select[name$='_sq']").change(function loopSQ() {
      // which field (get the prefix)
      //
      const fieldPrefix = ($j(this).attr('name').split('_'))[0];

      // update the shirt quantity with all size quantites
      //
      let shirts = 0;
      $j(`select[name^=${fieldPrefix}][name$=_sq]`).each(function loopFieldPrefixSQ() {
        // validate counting number
        //
        const qtyContender = $j(this).val();
        if (isCounting(qtyContender)) {
          shirts = parseInt(shirts, 10) + parseInt(qtyContender, 10);
        }
      });
      $j(`input[name^=${fieldPrefix}_q]`).val(shirts);

      // price
      //
      const price = $j(`#${fieldPrefix}_c`).html().replace('$', '').replace(',', '');

      // get the line total
      //
      const total = totFromQtyAndPrice(shirts, price);

      //  display it
      //
      $j(`#${fieldPrefix}_t`).val(formatCurrency(total));

      // update page subtotals
      //
      updateItemShipQty();
      onDeliveryTimeChange();
      totals();
    });

    // update totals when discount or donation are changed
    //
    $j('#discount,#donation').change(function loopDiscountDonation() {
      onDiscountDonationChange($j(this));
      totals();
    });

    // state was changed. shipping and tax implications?
    //
    $j('.state-proxy').change(function loopStateProxy() {
      onStateChange($j(this));
    });

    // delivery time was changed
    //
    $j('.delivery-time').change(() => {
      onDeliveryTimeChange();
    });

    /// / country was changed. shipping alert and update
    //
    $j('#country').change(() => {
      onCountryChange();
    });

    //  form submission attempt
    //
    $j('#catalog-order-form').find('.order-submitter').click(async function handleOrderSubmitterClick(event) {
      event.preventDefault();
      const submittingForm = $j(this).closest('form');

      if (isFormProcessing(submittingForm)) {
        addMessage('result', 'Hold on, still processing&hellip;');
        return;
      }

      markFormProcessing(submittingForm, true);
      $j(this).blur();
      clearMessagesHTML();

      // [0] gets htmlelements
      const arrayOfInvalidElements = bouncer.validateAll(submittingForm[0]);

      if (
        !Array.isArray(arrayOfInvalidElements)
        || arrayOfInvalidElements.length > 0
      ) {
        markFormProcessing(submittingForm, false);
        return;
      }

      if (validateOrderForm() === false) {
        markFormProcessing(submittingForm, false);
        return;
      }

      addMessage('result', 'Processing form&hellip;', 'green');
      const gaction = ($j('#liveOrTest').val() === 'test')
        ? 'order_form_test_submit'
        : 'order_form_submit';
      const gresponse = await grecaptchaV3Execute(gaction);

      if (
        !Object.prototype.hasOwnProperty.call(gresponse, 'success')
        || !gresponse.success
      ) {
        addMessage('result', 'Sorry, there was an error processing your order (err:03). Please let us know at info@veganoutreach.org.');
        markFormProcessing(submittingForm, false);
        return;
      }

      updateStateAndCountryShipAlert();

      if ($j(this).attr('id') === 'paypal-button') {
        $j('#payment_method').val('PayPal');
        const amountToSendToPaypal = $j('#grand').val().replace('$', '').replace(',', '');
        $j('#paypal-amount').val(amountToSendToPaypal);
      }

      let eaResponse;

      try {
        eaResponse = await subscribeToEveryAction(submittingForm);
      } catch (err) {
        addMessage('result', 'Sorry, there was an error processing your subscription (err:04). Please let us know at info@veganoutreach.org.'
          + ' Other parts of the order might still be processed.');
        logToPHP(`subscribeToEveryAction error: ${JSON.stringify(err)}`);
      }

      if (eaResponse.success) {
        addMessage('result', eaResponse.msg, 'green');
      }

      submitOrder(submittingForm);
    });

    keepFormUpToDate();
    window.setInterval(keepFormUpToDate, 1000);
  }

  $j.fn.serializeFormJSON = function serializeFormJSON() {
    const o = {};
    const a = this.serializeArray();

    $j.each(a, function loopA() {
      if (o[this.name]) {
        if (!o[this.name].push) {
          o[this.name] = [o[this.name]];
        }

        o[this.name].push(this.value || '');
      } else {
        o[this.name] = this.value || '';
      }
    });

    return o;
  };
});
